import getApiClient from '@/plugins/api'

export default {
  changePage: function (page) {
    this.page = page
  },

  loadItems() {
    const self = this,
      api = getApiClient(self.$root.$store)

    self.$store.commit('startLoading')

    self.searchParams.page = self.page
    self.searchParams.itemsPerPage = self.perPage

    api.get('categories', {
      params: self.searchParams
    })
      .then((result) => {
        self.items = result.data['hydra:member']
        self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
